import React from 'react';
import './MedicineCard.css';

// export interface Medicine {
//     id: number,
//     name: string,
//     price: number,
//     image: string
// }

// export interface MedicineCardProps {
//     key: number | string,
//     medicine: Medicine
// }

export const MedicineCard = ({medicine, variant = 'default'}) => {
    return <div key={medicine?.id} className={`${variant === 'detail' ? 'medicineCardDetailContainer' : 'medicineCardContainer'}`}>
        <div className="medicineImageThumbnail">
            <img src={`${medicine.image ? medicine.image : `https://picsum.photos/id/${Math.floor(Math.random() * 1000)}/200/300`}`} alt={medicine.name} />
        </div>

        {variant !== 'detail' && (
            <div className="medicineInfoContainer">
                <h4>{medicine?.name}</h4>
                <p><label>INR </label>{medicine?.price}</p>
                <label>Manufacturer</label> {medicine?.info?.["Manufacturer"]}
                <label>Packing</label> {medicine?.info?.["Packaging Type"]} {medicine?.info?.["Packaging Size"]}

                <div className="medicineActionContainer">
                    <button>Get More Details</button>
                </div>
            </div>)
        }

        {variant === 'detail' && (
            <div className="medicineInfoContainer">
                <h2>{medicine?.name}</h2>
                {/* <p className="medicinePrice"><label>INR </label>{medicine?.price}</p> */}
                <div className="medicineInfoTable">
                    < div className="table-row" >
                        <div className="medicineInfoKey">Price</div>
                        <div className="medicineInfoValue">{medicine?.price}</div>
                    </div>
                    {
                        Object.keys(medicine?.info).sort((a, b) => a.localeCompare(b)).map((key) => {
                            if (key === 'description') {
                                return null;
                            }
                            return (< div className="table-row" >
                                <div className="medicineInfoKey">{key}</div>
                                <div className="medicineInfoValue">{medicine?.info[key]}</div>
                            </div>)
                        })
                    }
                    <div className="table-row" >
                        <div className="medicineInfoKey">Description</div>
                        <div className="medicineInfoValue">{medicine?.info?.description}</div>
                    </div>
                </div>

            </div>)
        }
    </div >
};